import React from 'react';

import CountOfTotal from '../../../../../../../components/CountOfTotal';
import TextAreaForm from '../../../../../../../components/form/TextAreaForm';
import Modal from '../../../../../../../components/Modal';
import InfoForm from '../../../../../../../components/outline/InfoForm';
import { MAXIMUM_NUMBER_OF_ADMIN_MEMO_TEXT } from '../../../../../../../constants/service/common/commonConstants';
import './EditAccountUserStatusModal.scss';

const EditAccountUserStatusModal = (props) => {
  const { form, isOpen, onSubmitEditDetailInfo, onCloseModal } = props;

  return (
    <Modal
      title="유저 편집하기"
      isOpen={isOpen}
      width={650}
      height={300}
      isFooter={true}
      okText="저장"
      onOk={onSubmitEditDetailInfo}
      onClose={onCloseModal}
    >
      <InfoForm className="edit-user-status-modal-wrap">
        {/*추천 태그 리스트 메모*/}
        <TextAreaForm
          form={form}
          label={
            <span>
              관리자 메모
              <CountOfTotal content={form.getFieldValue('memo')} maxCnt={MAXIMUM_NUMBER_OF_ADMIN_MEMO_TEXT} />
            </span>
          }
          maxLength={MAXIMUM_NUMBER_OF_ADMIN_MEMO_TEXT}
          initialValue={''}
          subContent={
            <>
              <div>* 유저 편집 시 남길 메모를 입력해주세요.</div>
              <div>변경사유 혹은 관련된 jira, 1:1문의, 채널톡 url 등</div>
            </>
          }
          name="memo"
          autoSize={{ minRows: 6, maxRows: 50 }}
        />
      </InfoForm>
    </Modal>
  );
};

export default EditAccountUserStatusModal;
